module.exports = __webpack_public_path__ + "static/media/SWSCRC6-52.01fb2f22.mp3";